module.exports = __webpack_public_path__ + "static/media/599.756(4).ec13f242.pdf";